import React from 'react';
import Chart from './Chart';

export default function StackedBarChart(props) {

  const stackedBarOption = {
    chart: {
      type: 'column'
    },
    yAxis: {
      min: 0,
      max: 100,
      title: {
        text: ''
      },
      reversedStacks: false,
      labels:{
        formatter: function() {
          return this.value+"%";
        }
      }
    },
    tooltip: {
      pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y:.0f}%</b><br/>',
      shared: true,
      valueSuffix: '%'
    },
    plotOptions: {
      column: {
        stacking: 'normal'
      }
    }
  }

  function serieOption(data) {
    return {
      ...stackedBarOption,
      series: data.series,
      xAxis: {
        categories: data.categories
      }
    }
  }

  return (
    <Chart
      options={serieOption(props.data)}
      legendOptions={props.legendOptions}
    />
  )

}
